'use client';

import { ArrowUpRight } from '@phosphor-icons/react';

function VKIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M12.785 16.241s.288-.032.436-.194c.136-.148.132-.427.132-.427s-.02-1.304.587-1.496c.596-.19 1.362 1.26 2.174 1.817.613.42 1.08.328 1.08.328l2.17-.03s1.135-.07.597-.964c-.044-.073-.314-.661-1.618-1.869-1.366-1.265-1.183-1.06.462-3.248.998-1.33 1.398-2.143 1.273-2.49-.12-.331-.856-.244-.856-.244l-2.44.015s-.18-.025-.315.056c-.13.079-.215.263-.215.263s-.387 1.028-.9 1.902c-1.088 1.85-1.523 1.948-1.7 1.834-.413-.267-.31-1.075-.31-1.648 0-1.79.272-2.537-.53-2.73-.266-.064-.462-.106-1.142-.113-.873-.009-1.612.003-2.03.208-.278.136-.493.44-.362.457.161.022.527.099.72.363.25.34.24 1.104.24 1.104s.144 2.107-.335 2.369c-.328.18-.778-.187-1.744-1.865-.494-.86-.868-1.81-.868-1.81s-.072-.176-.2-.27c-.155-.115-.372-.151-.372-.151l-2.32.015s-.348.01-.476.161c-.114.134-.009.412-.009.412s1.82 4.258 3.882 6.403c1.889 1.966 4.033 1.838 4.033 1.838h.972z" />
    </svg>
  );
}

const SOCIALS = [
  {
    name: 'ВКонтакте',
    handle: 'aziatochka_ru',
    description: 'Фото, конкурсы и общение',
    href: 'https://vk.com/aziatochka_ru',
    gradient: 'linear-gradient(135deg, #5181B8 0%, #3F6DA5 100%)',
    shadow: 'rgba(81, 129, 184, 0.25)',
  },
];

export function AboutCTA() {
  return (
    <section className="py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="animate-fade-up">
          {/* Two-column layout */}
          <div className="grid lg:grid-cols-5 gap-10 lg:gap-16 items-start">

            {/* Left — text */}
            <div className="lg:col-span-2 lg:sticky lg:top-32">
              <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[var(--primary)] mb-4">
                На связи
              </span>
              <h2 className="text-2xl sm:text-3xl font-heading font-black tracking-tight text-[var(--text-primary)] leading-tight mb-4">
                Рады знакомству,{' '}
                <span className="text-[var(--primary)]">друзья</span>
              </h2>
              <p className="text-sm sm:text-base text-[var(--text-secondary)] leading-relaxed">
                Присоединяйтесь к нам в соцсетях — там контент, плюшки, немного сарказма и вкусные фото.
              </p>
            </div>

            {/* Right — social cards */}
            <div className="lg:col-span-3 space-y-4">
              {SOCIALS.map((social, i) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block animate-fade-up"
                  style={{ animationDelay: `${i * 100 + 100}ms` }}
                >
                  <div className="relative rounded-2xl border border-[var(--border-default)] bg-[var(--surface-primary)] p-5 sm:p-6 transition-all duration-400 hover:border-[var(--border-hover)] hover:shadow-xl hover:-translate-y-0.5">
                    <div className="flex items-center gap-4 sm:gap-5">
                      {/* Icon */}
                      <div
                        className="shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center transition-transform duration-500 group-hover:scale-110"
                        style={{
                          background: social.gradient,
                          boxShadow: `0 8px 24px ${social.shadow}`,
                        }}
                      >
                        <VKIcon className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
                      </div>

                      {/* Info */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-0.5">
                          <span className="text-base sm:text-lg font-bold text-[var(--text-primary)] group-hover:text-[var(--primary)] transition-colors duration-300">
                            {social.name}
                          </span>
                          <span className="text-xs text-[var(--text-tertiary)] font-mono">
                            {social.handle}
                          </span>
                        </div>
                        <p className="text-xs sm:text-sm text-[var(--text-secondary)]">
                          {social.description}
                        </p>
                      </div>

                      {/* Arrow */}
                      <div className="shrink-0">
                        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-[var(--surface-secondary)] flex items-center justify-center transition-all duration-300 group-hover:bg-[var(--primary)] group-hover:shadow-lg">
                          <ArrowUpRight
                            weight="bold"
                            className="w-4 h-4 sm:w-5 sm:h-5 text-[var(--text-tertiary)] transition-all duration-300 group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              ))}

              {/* Subtle tagline */}
              <p className="text-center text-xs text-[var(--text-tertiary)] pt-2">
                Отдыхайте, смейтесь, делитесь впечатлениями — мы рядом
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
